/**
 * Provides easy access to the location API.
 *
 * More info: <a href="https://developer.mozilla.org/en-US/docs/Web/API/Location">
 *   https://developer.mozilla.org/en-US/docs/Web/API/Location</a>
 *
 * @package Utils
 * @example
 * import { useLxLocation} from '@lxo-blocks/react'
 *
 * function MyComponent() {
 *   const location = useLxLocation();
 *   ...
 * }
 */
export default function useLxLocation(): Location {
  return window.location;
}
